import { AsyncThunk, AsyncThunkConfig, createAsyncThunk } from "@reduxjs/toolkit";
import { FeedComponentInfo } from "../../Services";
import { FeedComponentsResponse, GET_FEED_COMPONENTS_INFO } from "../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedComponentsCall";
import { fetchByIdFactory } from "./fetchByIdFactory";


export const fetchFeedComponentByIdsThunk = createAsyncThunk(
  `feedComponents/fetchByIds`,
  fetchByIdFactory<FeedComponentsResponse, FeedComponentInfo>(GET_FEED_COMPONENTS_INFO, (component) => component.data.feedComponent.info)
) satisfies AsyncThunk<FeedComponentInfo[], number[], AsyncThunkConfig> as AsyncThunk<FeedComponentInfo[], number[], AsyncThunkConfig> 
// Explicit typing is required